module.exports = __webpack_public_path__ + "img/gift.48d8ae85.svg";